import React, { FC } from 'react';
import { Box, Card } from '@mui/material';
import { ChatConversa } from '../../components/chat/chat';
import { Message } from '../../components/chat/types';

export interface CategoryProps {
  messages: Message[];
  input: string;
  setInput: (input: string) => void;
  setMessages: (message: Message) => Promise<void>;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  conversationId?: string;
  onResolveConversationId?: () => Promise<string | undefined>;
}

export const Chat: FC<CategoryProps> = ({
  messages,
  input,
  setInput,
  setMessages,
  loading = false,
  setLoading,
  conversationId,
  onResolveConversationId,
}) => {
  return (
    <div className="xvia-category" id="chat-container">
      <Box>
        <Card
          sx={{
            position: 'relative',
            overflowX: 'visible',
            overflowY: 'visible',
            width: '100%',
            height: { xs: 320, sm: 360, md: 400 },
            borderRadius: '20px',
            overflow: 'visible',
            boxShadow: 4,
            bgcolor: '#DFE2E9',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: 300,
              left: -260,
              bottom: -70,
              zIndex: 10,
              display: { xs: 'none', md: 'block' }
            }}
            className="liaBirdImage"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/ia.gif`}
              alt={'AI'}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>
          <ChatConversa
            loading={loading}
            setLoading={setLoading}
            onSendMessage={setMessages}
            messages={messages}
            input={input}
            setInput={setInput}
            conversationId={conversationId}
            onResolveConversationId={onResolveConversationId}
          />
        </Card>
      </Box>
    </div>
  );
};
